import axios from "axios";

const baseURL = `${process.env.REACT_APP_BASE_URL}/api`; //"http://localhost:8000/api"; //

export const axiosClient = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor: automatically attach token if exists
axiosClient.interceptors.request.use(
  (config) => {
    // Get token from localStorage or cookies
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Response interceptor: unwrap response data or return pagination if available
axiosClient.interceptors.response.use(
  (response) => {
    const responseData = response.data;
    return responseData.pagination ? responseData : responseData.data;
  },
  (error) => {
    const message =
      error.response?.data?.message || error.message || "Something went wrong.";
    const status = error.response?.status;
    const pathname = window.location.pathname;

    // Handle specific error codes
    if (status === 401 && pathname !== "/xac-thuc/dang-nhap") {
      // Token expired or invalid, clear token and redirect to login

      localStorage.removeItem("token");
      window.location.href = "/xac-thuc/dang-nhap";
    }

    return Promise.reject(new Error(message));
  },
);

export default axiosClient;
